import { API_URL } from "../constants";
import { getHeaders } from "../utils";

export const getProperties = async () => {
  const response = await fetch(`${API_URL}/api/properties`, {
    method: "GET",
    headers: getHeaders(),
  });
  return response.json();
};

export const getProperty = async (propertyId) => {
  const response = await fetch(`${API_URL}/api/properties/${propertyId}`, {
    method: "GET",
    //headers: getHeaders(),
  });
  return response.json();
};

export const updateProperty = async (propertyId, payload) => {
  const response = await fetch(`${API_URL}/api/properties/${propertyId}`, {
    method: "PUT",
    body: JSON.stringify(payload),
    headers: getHeaders(),
  });
  return response.json();
};

export const addProperty = async (payload) => {
  const response = await fetch(`${API_URL}/api/properties`, {
    method: "POST",
    body: JSON.stringify(payload),
    headers: getHeaders(),
  });
  return response.json();
};
